import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core/';
import { MessageService } from 'primeng/api';
import { DictionaryEntry } from '../../../models/dictionary.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { DictionaryService } from '../../../services/dictionary/dictionary.service';

@Component({
  selector: 'app-dictionary',
  templateUrl: './dictionary.component.html',
  styleUrls: ['./dictionary.component.css']
})
export class DictionaryComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  selectedItem: DictionaryEntry = new DictionaryEntry();
  addEditForm: FormGroup;
  showDuplicateDialog = false;
  showDetail = false;
  currentAction = '';
  titleAction = '';
  newDataAvailable = false;
  fields: any;
  invalidSubmit: boolean;
  dialogTitlesList: any = {};
  dialogTitle: string;
  numberFilter = KontableComponent.NumberFilter;

  constructor(
    public dictionaryService: DictionaryService,
    private fb: FormBuilder,
    private srvNotify: MessageService,
    private srvTranslate: TranslateService
  ) { }

  ngOnInit() {

    this.addEditForm = this.fb.group({
      'id': new FormControl(this.selectedItem.id),
      'company_id': new FormControl(this.selectedItem.company_id),
      'component': new FormControl(this.selectedItem.component),
      'nls_code': new FormControl(this.selectedItem.nls_code),
      'sub_component': new FormControl(this.selectedItem.sub_component),
      'value': new FormControl(this.selectedItem.value),
      'info': new FormControl(this.selectedItem.info)
    });

    this.srvTranslate.get([
      'dictionaryOperation.add_title',
      'dictionaryOperation.edit_title',
      'dictionaryOperation.view_title'
    ])
    .subscribe(res => {
      this.dialogTitlesList.add_title = res['dictionaryOperation.add_title' ];
      this.dialogTitlesList.edit_title = res['dictionaryOperation.edit_title' ];
      this.dialogTitlesList.view_title = res['dictionaryOperation.view_title' ];
    });

    this.dictionaryService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.addEditForm.disable();
  }

  addEntry() {
    this.currentAction = 'add';
    this.dialogTitle = this.dialogTitlesList.add_title;
    this.addEditForm.enable();
    this.addEditForm.reset();
    this.showDetail = true;
  }

  editEntry(row) {
    this.dialogTitle = this.dialogTitlesList.edit_title;
    this.currentAction = 'edit';
    this.titleAction = 'Edit on ' + row.component + '(' + row.sub_component + ')';
    this.addEditForm.enable();
    this.addEditForm.reset(row);
    this.showDetail = true;
  }

  viewEntry(row) {
    this.currentAction = 'view';
    this.dialogTitle = this.dialogTitlesList.view_title;
    this.titleAction = 'View on ' + row.component + '(' + row.sub_component + ')';
    this.addEditForm.disable();
    this.addEditForm.reset(row);
    this.showDetail = true;
  }

  removeEntry(row) {
    this.dictionaryService.remove(row).subscribe( () => {
      this.reloadList ();
      // this.newDataAvailable = true;
    });
  }

  recoverEntry(row) {
    this.dictionaryService.recover(row).subscribe( () => {
      this.reloadList ();
      // this.newDataAvailable = true;
    });
  }

  saveEntry() {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    let value = this.addEditForm.getRawValue();

    if (this.currentAction === 'duplicate') {

      value.company_id = +value.company_id;
      console.log(value);
      if (value.company_id > 0) {
        this.showDetail = false;
        this.dictionaryService.duplicate(value).subscribe();
        this.showDuplicateDialog = false;
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Duplicate success'});
        this.reloadList ();
        // this.newDataAvailable = true;
      } else {
        this.srvNotify.add({severity: 'error', summary: 'Error', detail: 'Company id not ID'});
      }
    } else {
      this.showDetail = false;
      if (value.id) {
        this.dictionaryService.update(value).subscribe( (res) => {
          this.reloadList ();
          // this.newDataAvailable = true;
        });
      } else {
        this.dictionaryService.create(value).subscribe( () => {
          this.reloadList ();
          // this.newDataAvailable = true;
        });
      }
    }
  }

  reloadList() {
    this.newDataAvailable = false;
    this.dictionaryService.list().subscribe( () => {
      this.newDataAvailable = true;
    });
  }

  showDuplicateEntryDialog(row) {
    this.titleAction = 'Duplicate on ' + row.component + '(' + row.sub_component + ')';
    this.selectedItem = row;
    this.showDuplicateDialog = true;
  }

  confirmEntryDuplication(row) {
    this.currentAction = 'duplicate';
    this.showDuplicateDialog = false;

    this.addEditForm.enable();
    this.addEditForm.reset(this.selectedItem);

    this.showDetail = true;
  }

  closeDialogDetail() {
    this.currentAction = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/dictionary/dictionary.component.ts